import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-key */
import { useCallback } from 'react';
import { Stepper as MuiStepper, Step, StepLabel, styled, } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import LocationOnSharpIcon from '@mui/icons-material/LocationOnSharp';
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import { Label2, SubText, Caption, } from '../../atoms/typography';
import Button from '../../atoms/Button';
import { Tooltip } from '../../atoms/Tooltip';
const StyledStepper = styled(MuiStepper) `
  .MuiStep-root:first-of-type {
    padding-left: 0;
}`;
const StyledStep = styled(Step, {
    shouldForwardProp: prop => prop !== 'moduleColor',
}) `
  & .MuiStepLabel-root .Mui-completed, .MuiStepLabel-root .Mui-active {
    color: ${({ moduleColor, theme }) => moduleColor || theme.palette.modules.default || theme.palette.primary.main}
  }
`;
const StyledSkipNextIcon = styled(SkipNextIcon) `
  background-color: ${({ theme }) => theme.palette.action.disabledBackground};
  color: ${({ theme }) => theme.palette.text.disabled};
  border-radius: 50%;
`;
;
const Stepper = ({ steps, currentStep, skippedSteps = [], ...muiStepperProps }) => {
    const stepIndex = steps.findIndex((stepOption) => {
        return stepOption.key.toLowerCase() === currentStep?.toLowerCase();
    });
    const filterStatusColor = useCallback((colorString) => {
        return [
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning',
            'disabled',
            'action',
            'inherit',
        ].includes(colorString) ? colorString : undefined;
    }, []);
    return _jsx(StyledStepper, { activeStep: stepIndex, sx: { flex: 1 }, ...muiStepperProps, children: !!steps.length && steps.map(({ key, label, detail, skipped, alternativeIconIndex = 0, alternativeColor = 'primary', alternativeColorForLabel, moduleColor, buttonText, buttonHandler, buttonDisabled, helpText, }, index) => {
            let iconContent = null;
            const icons = {
                1: _jsx(CheckCircleOutlineIcon, { color: filterStatusColor(alternativeColor), sx: { color: alternativeColor } }),
                2: _jsx(LocationOnSharpIcon, { color: filterStatusColor(alternativeColor), sx: { color: alternativeColor }, fontSize: 'large' }),
                3: _jsx(PanoramaFishEyeIcon, { color: 'disabled', fontSize: 'small' }),
            };
            const isSkipped = skipped || skippedSteps.includes(key);
            if (!isSkipped && alternativeIconIndex > 0) {
                iconContent = (icons[alternativeIconIndex]);
            }
            else {
                iconContent = (isSkipped && stepIndex > index ? _jsx(StyledSkipNextIcon, {}) :
                    undefined);
            }
            const alternativeTextColor = (alternativeColor === 'success' || alternativeColor === 'warning') ?
                `${alternativeColor}.main` : alternativeColor;
            let labelColor = alternativeColorForLabel ? alternativeTextColor : 'text.primary';
            if (isSkipped) {
                labelColor = 'text.disabled';
            }
            return (_jsx(StyledStep, { moduleColor: moduleColor, completed: stepIndex > index && !isSkipped, children: buttonText ? (_jsx(Button, { variant: "contained", onClick: buttonHandler, label: buttonText, disabled: buttonDisabled, helpText: helpText })) :
                    (_jsx(StepLabel, { icon: iconContent, optional: detail && _jsx(Caption, { children: detail }), children: (() => {
                            const labelElement = stepIndex >= index ?
                                _jsx(Label2, { color: labelColor, children: label }) :
                                _jsx(SubText, { color: 'text.secondary', children: label });
                            return helpText ? (_jsx(Tooltip, { text: helpText, placement: "bottom", children: _jsx("span", { children: labelElement }) })) : labelElement;
                        })() })) }, label));
        }) });
};
export default Stepper;
//# sourceMappingURL=index.js.map